import { render, staticRenderFns } from "./DeactivatingUserManagement.vue?vue&type=template&id=e6fec8c8&scoped=true"
import script from "./DeactivatingUserManagement.vue?vue&type=script&lang=js"
export * from "./DeactivatingUserManagement.vue?vue&type=script&lang=js"
import style0 from "./DeactivatingUserManagement.vue?vue&type=style&index=0&id=e6fec8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6fec8c8",
  null
  
)

export default component.exports